import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MenuItem, SubMenu } from '../../MenuItem'
import MediaQuery from 'react-responsive'
import slugify from 'react-slugify'

class CategoryMenuItems extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showSubmenu: ''
    }
    this.hideSubmenu = this.hideSubmenu.bind(this)
    this.showSubmenu = this.showSubmenu.bind(this)
  }

  hideSubmenu () {
    this.setState({ showSubmenu: '' })
  }
  showSubmenu (currentId) {
    this.setState({ showSubmenu: currentId })

    var linkSubmenu = document.querySelectorAll('.item-checked ~ .submenuCategories .link-profile')
    Array.from(linkSubmenu).forEach(link => {
      link.addEventListener('blur', function (event) {
        setTimeout(() => {
          if (document.querySelectorAll('.item-checked ~ .submenuCategories .link-profile:focus').length === 0) {
            if (document.querySelectorAll('.item-checked').length > 0) {
              let itemsChecked = document.querySelector('.item-with-submenu.item-checked')
              document.querySelector('.item-checked ~ input[type="radio"]:checked').checked = false
              itemsChecked.classList.remove('item-checked')
            }
          }
        }, 300)
      })
    })
  }
  checkAllowedTypes (type) {
    switch (type.toLowerCase()) {
      case 'category':
      case 'sub-category':
      case 'dynamic':
      case 'services':
      case 'services-external':
        return true
      default:
        return false
    }
  }

  hideThisMenu () {
    var activeButton = document.querySelector('button.link-menu-active')

    if (activeButton) {
      activeButton.attributes.removeNamedItem('aria-expanded')
      activeButton.setAttribute('aria-expanded', 'false')
      activeButton.classList.remove('link-menu-active')
    }
  }
  MaxLength = value => (value.length > 30 ? value.substring(0, 29) : value)

  render () {
    return (
      this.props.items.length > 0 && this.checkAllowedTypes(this.props.type) ? (
        <ul className={`submenu zindex-high txt-left radius py-0 ${this.props.className}`} onMouseEnter={() => this.hideSubmenu()}>
          <MediaQuery maxWidth={1024}>
            <li className='close-hamburger-menu bg-brand-4 color-ui-white px-2 mb-1'>
              <a
                onClick={this.hideThisMenu}
                className={`mn-item color-ui-white close-menu d-flex align-items-center`}
                tabIndex={0}
              >
                <i className='icon icon_left_app color-ui-white mr-1' aria-hidden='true' />
                Voltar
              </a>
            </li>
          </MediaQuery>
          {this.props.items.map((ele, index) => {
            return <li className={`txt-left p-0 m-0 pos-initial cat-${slugify(this.MaxLength(ele.label), { delimiter: '-' })}`}>
              <MenuItem
                key={index}
                indexParent={this.props.indexParent}
                indexItem={index}
                type={ele.type || this.props.type}
                {...ele}
                hasItems={ele.items && ele.items.length > 0}
                showSubmenu={this.showSubmenu}
                checked={this.state.showSubmenu === `${ele.type || this.props.type}_${this.props.indexParent}_${index}`}
                handleKeyEsc={this.props.handleKeyEsc}
              />
              <input
                checked={this.state.showSubmenu === `${ele.type || this.props.type}_${this.props.indexParent}_${index}`}
                className='d-none submenuCategories-radio'
                type='radio'
                id={`${ele.type || this.props.type}_${this.props.indexParent}_${index}`}
                name={`submenuCategories-radio`}
              />
              { ele.items && ele.items.length > 0
                ? <ul aria-hidden={this.state.showSubmenu !== `${ele.type || this.props.type}_${this.props.indexParent}_${index}`} aria-label={ele.label} id={`submenu-${ele.type || this.props.type}_${this.props.indexParent}_${index}`} className='submenuCategories bg-white' onClick={() => this.hideSubmenu()}>
                  <SubMenu
                    parentLabel={ele.label}
                    indexParent={this.props.indexParent}
                    indexItem={index}
                    type={ele.type || this.props.type}
                    items={ele.items}
                    hideSubmenu={this.hideSubmenu}
                    path={ele.path}
                  />
                </ul>
                : '' }
            </li>
          })}
        </ul>
      ) : null
    )
  }
}

CategoryMenuItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(MenuItem.propTypes)).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  indexParent: PropTypes.number,
  handleKeyEsc: PropTypes.func
}

export default CategoryMenuItems



// WEBPACK FOOTER //
// ./src/App/MainMenu/CategoryMenu/CategoryMenuItems/CategoryMenuItems.js